import React, { useEffect, useRef, useState } from "react"
import Div100vh from "react-div-100vh"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper.min.css"
import "swiper/components/effect-coverflow/effect-coverflow.min.css"
import "swiper/components/pagination/pagination.min.css"
import SwiperCore, { EffectCoverflow, Pagination } from "swiper/core"
import "./Favourites.css"
// import FavouriteCard from "../../components/FavouriteCard"
import "./Compare.css"
import { io } from "socket.io-client"
import { useStore } from "../../components/ApartmentFinder/State/Store"
import FavouriteCard2 from "../../components/FavouriteCard/FavouriteCard2"

SwiperCore.use([EffectCoverflow, Pagination])

export default function Compare(props) {
  const { favouritesData, setShow } = props
  const selectedFavourite = useStore(state => state.selectedFavourite)
  const setSelectedFavourite = useStore(state => state.setSelectedFavourite)
  const [swiper, setSwiper] = useState(null)
  const leftRef = useRef()
  const rightRef = useRef()
  const socket = useRef()
  const apartments = useStore(state => state.apartments)
  const favourites = useStore(state => state.favourites)
  const favouriteApartments = apartments.filter(a =>
    favourites.includes(a.PlotNumber)
  )

  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE

  const click = e => {
    if (e.target === leftRef.current || e.target === rightRef.current) {
      setShow(false)
    }
  }

  useEffect(() => {
    /**
     * Make a socket connection if there is a role.
     */

    if (role) {
      socket.current = io(url)
      if (role === "recipient") {
        socket.current.on("favourites", data => {
          if (data[0] === false) {
            setShow(false)
          } else {
            if (data[0] && swiper) {
              try {
                swiper.slideTo(data[1])
              } catch (error) {}
            }
          }
        })
      }
    }
  }, [swiper])

  const slideChange = e => {
    if (socket.current && role === "sender") {
      socket.current.emit("favourites", [true, e.activeIndex])
    }
  }

  favouriteApartments.filter(f => f.PlotNumber !== selectedFavourite)

  return (
    <Div100vh className="compare-favourites" onClick={click}>
      <div className="left" ref={leftRef}>
        <Swiper
          slidesPerView={1}
          loop={true}
          direction="vertical"
          grabCursor={true}
          navigation={true}
          pagination={{
            clickable: true
          }}
          onSwiper={setSwiper}
          onSlideChange={slideChange}
          className="swiper"
        >
          {favouriteApartments
            .filter(f => f.PlotNumber !== selectedFavourite)
            .map((fav, index) => (
              <SwiperSlide
                onClick={() => setSelectedFavourite(fav.PlotNumber)}
                key={index}
              >
                <div style={{ width: "880px", height: "650px" }}>
                  <FavouriteCard2
                    id={fav.PlotNumber}
                    hasEle={false}
                    // floor_no={fav.FloorLevel}
                    showButtons={false}
                  />
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
      <div className="right" ref={leftRef}>
        {selectedFavourite ? (
          <div style={{ width: "880px", height: "650px" }}>
            <FavouriteCard2
              hasEle={false}
              showButtons={false}
              id={selectedFavourite}
              onClick={() => setSelectedFavourite(null)}
            />
          </div>
        ) : (
          <div className="slot">Select an apartment to compare</div>
        )}
      </div>
    </Div100vh>
  )
}
